import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { AnimatedAlert } from 'src/components/molecules/animated-alert/animated-alert'
import { useAnimatedAlert } from 'src/components/molecules/animated-alert/animated-alert-provider'
import { useGetVessel } from 'src/hooks/queries/vessels/use-get-vessel'
import { useGetMe } from '~hooks/queries/me/use-get-me'
import AnimatedHeart from '~pages/pages-behind-login/chartering/position-list-page/components/position-list-table/vessel-name-content/animated-heart'
import { useVesselNavigation } from '~pages/pages-behind-login/vessel-page/vessel-page-content/sub-components/auto-complete-and-favorites'
import { capitalizeStringWords } from '~utils/capitalize-string-words'

export function FavoritesSelect() {
  const { setStatus } = useAnimatedAlert()
  const { vesselId } = useParams()
  const [searchParams] = useSearchParams()
  const { data } = useGetMe()
  const [selectedVesselId, setSelectedVesselId] = useState<string>()
  const { data: fetchedVessel, isError: isErrorFetchingVessel } = useGetVessel({
    vesselId: selectedVesselId,
  })
  const navigateToVessel = useVesselNavigation()

  useEffect(() => {
    if (fetchedVessel) {
      navigateToVessel(fetchedVessel)
    }
  }, [fetchedVessel])

  useEffect(() => {
    if (isErrorFetchingVessel) {
      setStatus(
        'Vessel not found, you may not have access to this vessel.',
        undefined,
        'error',
      )
    }
  }, [isErrorFetchingVessel])

  const favoriteVessels = data?.favoriteVesselsNames || []

  if (!favoriteVessels.length) {
    return null
  }

  const selectOptions = favoriteVessels
    .map((item) => ({
      label: capitalizeStringWords(item.vesselName),
      value: item._id,
      icon: <AnimatedHeart filled />,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  const currentVesselId = vesselId || searchParams.get('vesselId')
  const favorite = selectOptions.find(
    (option) => option.value === currentVesselId,
  )

  return (
    <>
      <FormControl size="small" sx={{ width: '300px' }}>
        <InputLabel id="favorite-vessels">Favorite Vessels</InputLabel>
        <Select
          name="favorite-vessels"
          value={favorite?.value || ''}
          label="Favorite Vessels"
          onChange={(e) => setSelectedVesselId(e.target.value)}
        >
          {selectOptions.map((option) => (
            <MenuItem key={option.label} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <AnimatedAlert />
    </>
  )
}
